// @ts-expect-error - TS2305 - Module '"monet"' has no exported member 'MaybeType'.
import { Maybe, type MaybeType } from 'monet';
import {
	type BlueprintModuleKey,
	customBlueprintModuleKey,
	type SummaryBlueprint,
} from '../../../model';
import type { State } from '../../types';
import { maybeResult, maybeEntities, getUI } from '../base';

export const getBlueprintModuleKeys = (state: State): BlueprintModuleKey[] =>
	maybeResult(state)
		// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type.
		.map((result) =>
			// @ts-expect-error - TS7006 - Parameter 'blueprint' implicitly has an 'any' type.
			result.blueprints.filter((blueprint) => blueprint !== customBlueprintModuleKey),
		)
		.orSome([]);

export const getSelectedBlueprintModuleKey = (state: State): BlueprintModuleKey =>
	getUI(state).selectedBlueprint;

export const isBlueprintDialogOpen = (state: State): boolean => getUI(state).isBlueprintDialogOpen;

export const isSelected = (state: State, blueprintModuleKey: BlueprintModuleKey) =>
	getSelectedBlueprintModuleKey(state) === blueprintModuleKey;

const maybeBlueprint = (
	state: State,
	blueprintModuleKey: BlueprintModuleKey,
): MaybeType<SummaryBlueprint> =>
	// @ts-expect-error - TS7006 - Parameter 'entities' implicitly has an 'any' type.
	maybeEntities(state).flatMap((entities) =>
		Maybe.fromNull(entities.blueprints[blueprintModuleKey]),
	);

export const maybeName = (
	state: State,
	blueprintModuleKey: BlueprintModuleKey,
): MaybeType<string> =>
	// @ts-expect-error - TS7006 - Parameter 'blueprint' implicitly has an 'any' type.
	maybeBlueprint(state, blueprintModuleKey).map((blueprint) => blueprint.name);

export const maybeDescription = (
	state: State,
	blueprintModuleKey: BlueprintModuleKey,
): MaybeType<string> => {
	if (blueprintModuleKey === customBlueprintModuleKey) {
		return Maybe.None();
	}
	// @ts-expect-error - TS7006 - Parameter 'blueprint' implicitly has an 'any' type.
	return maybeBlueprint(state, blueprintModuleKey).flatMap((blueprint) =>
		Maybe.fromNull(blueprint.description),
	);
};
